export type ChamberLayout = {
  chambersAcross: number;
  chambersDown: number;
  chamberRows: number;
  chamberCols: number;
};

export const CHAMBER_LAYOUTS: Record<string, ChamberLayout> = {
  '2 Chamber (horizontal)': {
    chambersAcross: 2,
    chambersDown: 1,
    chamberRows: 2,
    chamberCols: 2,
  },
  '6 Chamber': {
    chambersAcross: 3,
    chambersDown: 2,
    chamberRows: 2,
    chamberCols: 2,
  },
  '2 Chamber (vertical)': {
    chambersAcross: 1,
    chambersDown: 2,
    chamberRows: 3,
    chamberCols: 2,
  },
  '3 Chamber': {
    chambersAcross: 3,
    chambersDown: 1,
    chamberRows: 2,
    chamberCols: 2,
  },
};

const ICON_LAYOUTS: Record<string, ChamberLayout> = {
  ...CHAMBER_LAYOUTS,
  HeraCell: {
    chambersAcross: 1,
    chambersDown: 1,
    chamberRows: 5,
    chamberCols: 5,
  },
  Astec: { chambersAcross: 5, chambersDown: 2, chamberRows: 2, chamberCols: 1 },
  ImvPlaner: CHAMBER_LAYOUTS['2 Chamber (horizontal)'],
  IvfTech: CHAMBER_LAYOUTS['6 Chamber'],
};

export const getIncubatorIconLayout = (
  incubatorType: string,
): ChamberLayout | undefined => ICON_LAYOUTS[incubatorType];
